module.exports = __webpack_public_path__ + "img/question-active.1aba1ce3.svg";